var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.71354 2.75H17.7448C18.7474 2.75 19.5677 3.54931 19.5677 4.52625V6.48012C19.5677 7.19062 19.112 8.07875 18.6563 8.52281L14.737 11.8977C14.1901 12.3417 13.8255 13.2299 13.8255 13.9404V17.7593C13.8255 18.2922 13.4609 19.0027 13.0052 19.2691L11.7292 20.0684C10.5443 20.7789 8.90365 19.9796 8.90365 18.5586V13.8516C8.90365 13.2299 8.53906 12.4306 8.17448 11.9865L4.71094 8.434C4.25521 7.98994 3.89062 7.19062 3.89062 6.65775V4.61506C3.89062 3.54931 4.71094 2.75 5.71354 2.75Z",
    stroke: "#181EB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7552 2.75L6.26172 9.76619",
    stroke: "#181EB6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlue);
export default __webpack_public_path__ + "static/media/filterBlue.3ccce5cea4626c79c4cafdac1b15fe44.svg";
export { ForwardRef as ReactComponent };